import { render, staticRenderFns } from "./AddFttbAddonModal.vue?vue&type=template&id=2595cb8a&"
import script from "./AddFttbAddonModal.vue?vue&type=script&lang=js&"
export * from "./AddFttbAddonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports